import { isSameDay } from 'date-fns'
import { formatDateAndHoursMinutes, formatHoursMinutes, toDate } from 'util/date/formatDate'

export function formatDateHistoricoRegulacao(date: LocalDate, dateToCompare: Date): string {
  if (isSameDay(toDate(date), dateToCompare)) {
    return `hoje às ${formatHoursMinutes(date)}`
  } else {
    return `em ${formatDateAndHoursMinutes(date)}`
  }
}
